import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const validateLiveEventEnrollments = async (payload, accessToken) => {
  const response = await axios.post(
    `${API_BASE_URL}/api/dev/live-events/enrollments/bulk/validate`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return response.data;
};

export const upsertLiveEventEnrollments = async (payload, accessToken) => {
  const response = await axios.post(
    `${API_BASE_URL}/api/dev/live-events/enrollments/bulk/upsert`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return response.data;
};